const getEnvLoadLevelsObject = ({
  environmentId,
  cameraId,
  dayTime,
  northyaw,
  noFade,
  applyDaytime,
  cameraData,
}: {
  environmentId: string | undefined;
  cameraId?: string;
  dayTime: number;
  northyaw?: number;
  noFade?: boolean;
  applyDaytime?: boolean;
  cameraData?: unknown;
}) => ({
  scenario_id: environmentId,
  camera_id: cameraId,
  daytime: dayTime,
  northyaw: northyaw,
  no_fade: noFade,
  apply_daytime: applyDaytime,
  camera: cameraData,
});

export default getEnvLoadLevelsObject;
